import { render, staticRenderFns } from "./AppOrder.vue?vue&type=template&id=257d6af9&scoped=true&"
import script from "./AppOrder.vue?vue&type=script&lang=js&"
export * from "./AppOrder.vue?vue&type=script&lang=js&"
import style0 from "./AppOrder.vue?vue&type=style&index=0&id=257d6af9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "257d6af9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VApp,VBtn,VCol,VIcon,VRow,VTooltip})
